import React from 'react'
import classNames from 'classnames'
import CheckBoxImage from '../../CheckBoxImage'

const GridListTdSelectable = ({ onSelect, icon, isChecked, gridView, color, disableMobile, iconText, disabledClick }) => {
  
  return (
    <td className={
      classNames(
        'viso-grid-list-td viso-grid-list-td--selectable',
        `viso-grid-list-td--${gridView} viso-grid-list-td--selectable--${gridView}`,
        !disableMobile && 'viso-grid-list-td--selectable--mobile-enabled',
        disabledClick && 'viso-grid-list-td--disabled-click'
      )}
    >
      <CheckBoxImage onClick={onSelect} icon={icon} iconText={iconText} isChecked={isChecked} color={color} onChange={() => { }} />
    </td>
  )
}

export default GridListTdSelectable